import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackageById } from '../../store/slices/packageSlice';

const PackageDetailsPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { currentPackage, loading } = useSelector((state) => state.packages);

  useEffect(() => {
    dispatch(fetchPackageById(id));
  }, [id, dispatch]);

  if (loading) {
    return (
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!currentPackage) {
    return (
      <Container>
        <Typography>Package not found</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        {currentPackage.name}
      </Typography>
      <Typography variant="body1" paragraph>
        {currentPackage.description}
      </Typography>
      <Typography variant="body2">
        Duration: {currentPackage.duration} days
      </Typography>
      <Typography variant="body2">
        Base Price: {currentPackage.currency === 'PKR' || /pakistan|swat|hunza|skardu|murree|lahore|naran/i.test(currentPackage.name || '')
          ? `PKR ${Number(currentPackage.basePrice).toLocaleString()}`
          : `${currentPackage.currency || '$'}${currentPackage.currency ? ' ' : ''}${Number(currentPackage.basePrice).toLocaleString()}`}
      </Typography>
    </Container>
  );
};

export default PackageDetailsPage;

